import { i18n } from "@/i18n";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";

export default {
  path: "/training",
  name: "Training",
  component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingLayoutView.vue"),
  redirect: { name: "TrainingList" },
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("page.training_list"),
  },
  children: [
    {
      path: "list",
      name: "TrainingList",
      component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingListView.vue"),
      meta: {
        title: i18n.global.t("page.training_list"),
        breadcrumb: false,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_DASHBOARD_TRAINING_LIST,
      },
    },
    {
      path: ":trainingId",
      name: "TrainingDashboardLayout",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      meta: {
        title: i18n.global.t("page.training_dashboard"),
        breadcrumb: true,
      },
      redirect: { name: "TrainingDashboard" },
      children: [
        {
          path: "dashboard",
          name: "TrainingDashboard",
          component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingDashboardView.vue"),
          meta: {
            title: i18n.global.t("page.training_dashboard"),
            breadcrumb: false,
            displayTrainingName: true,
          },
        },
        {
          path: ":alias(training)/edit",
          name: "TrainingEdit",
          component: () => import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/AddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.training.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            notGeneric: true,
            backPath: "TrainingDashboard",
            displayTrainingName: true,
          },
        },
        {
          path: "group/add/:trainingCourseId",
          name: "TrainingGroupAdd",
          component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingGroupAddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.add.title", 1, {
              name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            displayTrainingName: true,
          },
        },
        {
          path: "group/edit/:id",
          name: "TrainingGroupEdit",
          component: () => import(/* webpackChunkName: "training" */ "@/views/Training/TrainingGroupAddEditView.vue"),
          meta: {
            title: i18n.global.tc("global.edit.title", 1, {
              name: i18n.global.tc("studea_manager.group.title", 1).toLowerCase(),
            }),
            breadcrumb: true,
            displayTrainingName: true,
          },
        },
        {
          path: "group/:groupId/matching",
          name: "MatchingGroupDashboard",
          component: () => import(/* webpackChunkName: "training" */ "@/views/Training/MatchingGroupDashboardView.vue"),
          meta: {
            title: i18n.global.t("page.matching_group_dashboard"),
            breadcrumb: true,
            displayTrainingName: true,
          },
        },
      ],
    },
    {
      path: "contract/:registration/:group",
      name: "TrainingContract",
      component: () => import(/* webpackChunkName: "registration" */ "@/views/Registration/ContractSheetView.vue"),
      meta: {
        title: i18n.global.t("page.contract"),
        breadcrumb: true,
      },
    },
  ],
};
